import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import Dashboard from './pages/Dashboard';
import Collections from './pages/Collections';
import Products from './pages/Products';
import CreateCollection from './pages/CreateCollection';
import CreateProduct from './pages/CreateProduct';
import Orders from './pages/Orders';
import LandingPageSettings from './pages/LandingPageSettings';
import Analytics from './pages/Analytics';
import ProductAnalytics from './pages/ProductAnalytics';
import Coupons from './pages/Coupons';
import Subscribers from './pages/Subscribers';
import Login from './pages/Login';
import ProtectedRoute from './components/auth/ProtectedRoute';
import { AppProvider } from './context/AppContext';
import { AuthProvider, useAuth } from './context/AuthContext';
import './App.css';

// Main authenticated application
const AuthenticatedApp = () => {
  return (
    <AppProvider>
      <Router>
        <ProtectedRoute>
          <Layout>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/collections" element={<Collections />} />
              <Route path="/products/:collectionId?" element={<Products />} />
              <Route path="/create-collection" element={<CreateCollection />} />
              <Route path="/edit-collection/:id" element={<CreateCollection />} />
              <Route path="/create-product/:collectionId?" element={<CreateProduct />} />
              <Route path="/edit-product/:productId" element={<CreateProduct />} />
              <Route path="/orders" element={<Orders />} />
              <Route path="/coupons" element={<Coupons />} />
              <Route path="/subscribers" element={<Subscribers />} />
              <Route path="/landing-page-settings" element={<LandingPageSettings />} />
              <Route path="/analytics" element={<Analytics />} />
              <Route path="/analytics/product/:productId" element={<ProductAnalytics />} />
            </Routes>
          </Layout>
        </ProtectedRoute>
      </Router>
    </AppProvider>
  );
};

// Main App component with authentication wrapper
function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

// App content that responds to authentication state
const AppContent = () => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <ProtectedRoute />; // This will show the loading spinner
  }

  if (!isAuthenticated) {
    return <Login />;
  }

  return <AuthenticatedApp />;
};

export default App;
